import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Formik } from 'formik';

import PageHeading from '@RHEnvironmental/pattern-library/dist/js/components/PageHeading';
import PageSection from '@RHEnvironmental/pattern-library/dist/js/components/PageSection';
import LoadingIndicator from '@RHEnvironmental/pattern-library/dist/js/components/LoadingIndicator';
import InputContainer from '@RHEnvironmental/pattern-library/dist/js/components/InputContainer';
import CheckboxField from '@RHEnvironmental/pattern-library/dist/js/components/CheckboxField';
import InlineButtonPanel from '@RHEnvironmental/pattern-library/dist/js/components/InlineButtonPanel';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';
import AlertBox from '@RHEnvironmental/pattern-library/dist/js/components/AlertBox';
import OfficerList from '../../modules/OfficerList';
import MainLayout from '../../modules/MainLayout';
import OfficerInviteForm from '../../forms/OfficerInvite';

import style from './style.scss';
import * as providerManagementActions from '../../../actions/providerManagement';
import * as alertActions from '../../../actions/alerts';
import {
    onMarkAsDeactivated,
    updateServiceProvider,
} from '../../../actions/providerManagement';
import BodyText from '../../modules/BodyText';
import { setAlert } from '../../../actions/alerts';
import AddEditServiceProviderForm from '../../forms/AddEditServiceProvider';

const EditServiceProvider = ({
    match: {
        params: { id },
    },
    serviceProvider,
    officers,
    officerInvites,
    getServiceProvider,
    getServiceProviderOfficers,
    getServiceProviderOfficerInvites,
    reset,
    onSuccess,
    alert,
    clearAlert,
}) => {
    useEffect(() => {
        getServiceProvider(id);
        getServiceProviderOfficers(id);
        getServiceProviderOfficerInvites(id);
        clearAlert();
        return () => {
            reset();
        };
    }, [id]);

    const [showEditServiceProvider, setShowEditServiceProvider] =
        useState(false);
    const dispatch = useDispatch();
    return (
        <MainLayout>
            <PageSection className="page-section--fixed-width-container page-section--green">
                <PageHeading level={5} className="mb-4">
                    Platform Admin
                </PageHeading>
                <div className="mb-8">
                    <PageHeading level={4} className="mb-4">
                        Service Provider
                    </PageHeading>
                </div>
            </PageSection>
            {!serviceProvider ? (
                <PageSection className="page-section--fixed-width-container">
                    <LoadingIndicator show />
                </PageSection>
            ) : (
                <>
                    <PageSection className="page-section--fixed-width-container">
                        {!showEditServiceProvider ? (
                            <>
                                <PageHeading level={5} className="mb-4">
                                    {serviceProvider.name}
                                </PageHeading>
                                <PageHeading level={4}>
                                    Contact Name
                                </PageHeading>
                                <BodyText>
                                    {serviceProvider.contact_name}
                                </BodyText>
                                <PageHeading level={4}>
                                    Contact Email
                                </PageHeading>
                                <BodyText>
                                    {serviceProvider.contact_email}
                                </BodyText>
                                <PageHeading level={4}>
                                    Contact Phone
                                </PageHeading>
                                <BodyText>
                                    {serviceProvider.contact_phone}
                                </BodyText>
                            </>
                        ) : (
                            <>
                                <PageHeading level={5} className="mb-4">
                                    Edit Service Provider
                                </PageHeading>
                                <AddEditServiceProviderForm
                                    serviceProvider={serviceProvider}
                                    onCancel={() =>
                                        setShowEditServiceProvider(false)
                                    }
                                    onSuccess={() => {
                                        dispatch(
                                            setAlert(
                                                'Service provider updated.',
                                                'success'
                                            )
                                        );
                                        setShowEditServiceProvider(false);
                                        getServiceProvider(id);
                                    }}
                                />
                            </>
                        )}
                        {!showEditServiceProvider && (
                            <Button
                                className="button-edit"
                                onClick={() => setShowEditServiceProvider(true)}
                            >
                                Edit
                            </Button>
                        )}
                    </PageSection>
                    <PageSection className="page-section--fixed-width-container">
                        {alert &&
                            alert.message &&
                            alert.section === 'service-provider' &&
                            !alert.isModal && (
                                <AlertBox className="mb-4" theme={alert.theme}>
                                    <p>{alert.message}</p>
                                </AlertBox>
                            )}
                        <PageHeading level={5} className="mb-4">
                            Options
                        </PageHeading>
                        <Formik
                            initialValues={{
                                id: serviceProvider.id,
                                deactivated: serviceProvider.deactivated,
                            }}
                            onSubmit={(formValues, formHelpers) =>
                                dispatch(
                                    updateServiceProvider(
                                        formValues,
                                        formHelpers,
                                        onSuccess
                                    )
                                )
                            }
                            enableReinitialize
                        >
                            {({
                                setFieldValue,
                                values,
                                handleSubmit,
                                isSubmitting,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <InputContainer className="mb-4">
                                        <CheckboxField
                                            checked={values.deactivated}
                                            name="deactivated"
                                            value={values.deactivated}
                                            onChange={(e) =>
                                                onMarkAsDeactivated(
                                                    e.target.checked,
                                                    setFieldValue
                                                )
                                            }
                                        >
                                            Deactivated
                                        </CheckboxField>
                                    </InputContainer>
                                    <InlineButtonPanel>
                                        <Button
                                            onClick={handleSubmit}
                                            disabled={isSubmitting}
                                        >
                                            Save
                                        </Button>
                                    </InlineButtonPanel>
                                </form>
                            )}
                        </Formik>
                    </PageSection>
                    <PageSection className="page-section--fixed-width-container flex">
                        <PageSection className="page-section flex-05">
                            <PageHeading level={5} className="mb-4">
                                Officers
                            </PageHeading>
                            <OfficerInviteForm
                                serviceProviderId={serviceProvider.id}
                                onSuccess={() => {
                                    getServiceProviderOfficerInvites(
                                        serviceProvider.id
                                    );
                                }}
                            />
                        </PageSection>
                    </PageSection>
                    <PageSection className="page-section--fixed-width-container">
                        {officers.length > 0 || officerInvites.length > 0 ? (
                            <OfficerList
                                officerInvites={officerInvites}
                                officers={officers}
                                canEdit={false}
                            />
                        ) : (
                            <BodyText>
                                No officers have been invited yet.
                            </BodyText>
                        )}
                    </PageSection>
                </>
            )}
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    ...state.pages.providerManagement,
    alert: state.alerts.alert,
});

const mapDispatchToProps = (dispatch) => ({
    reset() {
        dispatch(providerManagementActions.reset());
    },
    clearAlert() {
        dispatch(alertActions.clearAlert());
    },
    getServiceProvider(id) {
        dispatch(providerManagementActions.getServiceProvider(id));
    },
    getServiceProviderOfficers(id) {
        dispatch(providerManagementActions.getServiceProviderOfficers(id));
    },
    getServiceProviderOfficerInvites(id) {
        dispatch(
            providerManagementActions.getServiceProviderOfficerInvites(id)
        );
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditServiceProvider);
